// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { oneTimeAddressFormStyles } from "@awc/Overrides/Widgets/CheckoutShipping/ShippingAddressForm";
import { GridItemProps } from "@insite/mobius/GridItem";

const formFieldSharedStyle: GridItemProps = { width: [12, 12, 6, 6, 6] };

oneTimeAddressFormStyles.formFields = {
    firstNameGridItem: { ...formFieldSharedStyle },
    lastNameGridItem: { ...formFieldSharedStyle },
    companyNameGridItem: { ...formFieldSharedStyle },
    attentionGridItem: { ...formFieldSharedStyle },
    address1GridItem: { ...formFieldSharedStyle },
    address2GridItem: { ...formFieldSharedStyle },
    address3GridItem: { ...formFieldSharedStyle },
    address4GridItem: { ...formFieldSharedStyle },
    addAddressLineLinkGridItem: { ...formFieldSharedStyle },
    countryGridItem: { ...formFieldSharedStyle },
    cityGridItem: { ...formFieldSharedStyle },
    stateGridItem: { ...formFieldSharedStyle },
    postalCodeGridItem: { ...formFieldSharedStyle },
    phoneGridItem: { ...formFieldSharedStyle },
    faxGridItem: { ...formFieldSharedStyle },
    emailGridItem: { ...formFieldSharedStyle },
}